export function getViteAppOktaClientId(): string {
  return import.meta.env.VITE_OKTA_CLIENT_ID;
}
